import React, { useEffect, useState } from "react";
import "../styles/HeroContenidoAds.scss";

import img1 from "../images/carousel/1.png";
import img2 from "../images/carousel/2.png";
import img3 from "../images/carousel/3.png";
import img4 from "../images/carousel/4.png";


const HeroContenidoAds = () => {
  const images = [img1, img2, img3, img4];
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setActive((p) => (p + 1) % images.length);
    }, 4500);
    return () => clearInterval(t);
  }, [images.length]);

  return (
    <section className="ovit-hero2" id="inicio">
      {/* FX background */}
      <div className="ovit-hero2__bg" aria-hidden="true">
        <div className="ovit-hero2__grid" />
        <div className="ovit-hero2__glow ovit-hero2__glow--1" />
        <div className="ovit-hero2__glow ovit-hero2__glow--2" />
      </div>

      <div className="ovit-hero2__container">
        {/* LEFT */}
        <div className="ovit-hero2__left">
          <div className="ovit-hero2__kicker">
            <span className="ovit-hero2__dot" aria-hidden="true" />
            <span>Contenido + Campañas para vender</span>
          </div>

          <h1 className="ovit-hero2__title">
            Atrae clientes{" "}
            <span className="ovit-hero2__grad">todos los días</span>
            <br />
            con contenido y anuncios bien hechos.
          </h1>

          <p className="ovit-hero2__subtitle">
            Nosotros creamos el contenido y gestionamos tus campañas. Tú te enfocas en atender
            mensajes y cerrar ventas.
          </p>

          <ul className="ovit-hero2__bullets">
            <li>✅ Publicaciones que generan confianza</li>
            <li>✅ Campañas segmentadas y optimizadas</li>
            <li>✅ Estrategia mensual + mejoras constantes</li>
          </ul>

          <div className="ovit-hero2__actions">
            <a className="ovit-hero2__btn" href="#planes">
              Ver planes
            </a>

            <a className="ovit-hero2__btn ovit-hero2__btn--ghost" href="https://wa.me/525588093678?text=Hola,%20me%20interesa%20recibir%20informaci%C3%B3n%20sobre%20sus%20servicios%20de%20marketing%20digital.%20Quiero%20hacer%20crecer%20mi%20negocio%20y%20generar%20m%C3%A1s%20clientes." target="_blank" rel="noopener noreferrer">
              Hablar por WhatsApp
            </a>
          </div>

          <div className="ovit-hero2__trust">
            <div className="ovit-hero2__pill">
              <span className="ovit-hero2__pillBig">+100</span>
              <span className="ovit-hero2__pillSmall">clientes</span>
            </div>
            <div className="ovit-hero2__pill">
              <span className="ovit-hero2__pillBig">+600</span>
              <span className="ovit-hero2__pillSmall">proyectos</span>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="ovit-hero2__right">
          <div className="ovit-hero2__preview">
            <div className="ovit-hero2__previewTop">
              <div className="ovit-hero2__chip">Es momento de vender !!!</div>
              <div className="ovit-hero2__dots" aria-hidden="true">
                <span />
                <span />
                <span />
              </div>
            </div>

            <div className="ovit-hero2__mainImg">
              <img src={images[active]} alt="Ejemplo de contenido OVIT" />
            </div>

            <div className="ovit-hero2__thumbs">
              {images.map((src, idx) => (
                <button
                  type="button"
                  key={idx}
                  className={`ovit-hero2__thumb ${active === idx ? "is-active" : ""}`}
                  onClick={() => setActive(idx)}
                  aria-label={`Ver imagen ${idx + 1}`}
                >
                  <img src={src} alt={`Miniatura ${idx + 1}`} />
                </button>
              ))}
            </div>

            <div className="ovit-hero2__note">
              *Contenido y campañas adaptadas a tu negocio, zona y objetivo.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroContenidoAds;